import * as Yup from "yup";
export const LineSchema = Yup.object({
    ADD_LINE_BOT_URL: Yup.string().optional(),
});
export function getLineConfig(env) {
    return {
        ADD_LINE_BOT_URL: env.REACT_APP_ADD_LINE_BOT_URL,
    };
}
//# sourceMappingURL=line.js.map